import { render, staticRenderFns } from "./BaseFrontOfficeFileInput.vue?vue&type=template&id=15bc8b1a&scoped=true"
import script from "./BaseFrontOfficeFileInput.vue?vue&type=script&lang=js"
export * from "./BaseFrontOfficeFileInput.vue?vue&type=script&lang=js"
import style0 from "./BaseFrontOfficeFileInput.vue?vue&type=style&index=0&id=15bc8b1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bc8b1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VFileInput})
